import { render } from "./WelcomeScreen.vue?vue&type=template&id=c09b3960&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=c09b3960&lang=scss&scoped=true"
import "./WelcomeScreen.vue?vue&type=style&index=1&id=c09b3960&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09b3960"]])

export default __exports__